import React from 'react';
import style from './styleSheet';
import { useParams } from 'react-router-dom';
import { capitalized } from '../../util/helperFunctions';
import projectData from '../../data/javascriptProjects';

import Card from '../Card';
import Button from '../Button';
import { useIsMobile } from '../../contexts/ViewportProvider';

const ProjectDetail = () => {
  const parameterId = useParams().id;
  const { isMobile } = useIsMobile();

  const mobileStyle = isMobile ? { width: '95%' } : '';

  const { name, gitHub, hostedUrl, image, description } = projectData.find(({ id }) => id === parameterId);


  return (
    <section className='sectionMargin'>
      <h1 style={style.projectDetailTitle}>{capitalized(name)}</h1>

      <Card style={{ ...mobileStyle, marginBottom: '4rem' }} shadow={true}>
        <a href={hostedUrl} target='_blank' rel='noreferrer'>
          <img style={style.imageContainer} src={image} alt={`screenshot of the ${name} project`} />
        </a>
      </Card>

      <Card style={{ ...mobileStyle, marginBottom: '4rem' }} shadow={true}>
        <p style={style.cardWidth}>
          {description}
        </p>
      </Card>

      <Card style={style.buttonContainer}>
        <Button
          href={gitHub} buttonName={'Repository'} />
        <Button href={hostedUrl} buttonName={'app demo'} />
      </Card>

    </section>
  );
};

export default ProjectDetail;